<script>
import Layout from "../../layouts/main";
import Style from "@/views/layouts/style";
import PageHeader from "@/components/Page-header";
import appConfig from "@/../app.config";
import CompanyAPI from "@/services/company/companyAPI";
import EmployeeAPI from "@/services/employee/employeeAPI";
import { required } from "vuelidate/lib/validators";
import pensionTrabajadoresAPI from "@/services/standards/pensionTrabajadores/pensionTrabajadoresAPI";
import uploadDocument from "../../../utils/digitalOcean/digitalocean-upload-file";
import Swal from "sweetalert2";
import newScoresAPI from "../../../services/newScores/newScoresAPI"
import CheckModal from "@/components/CheckModal";
import { sendNotification } from "@/utils/helpers/notification";
import CompanyItemsAPI from "@/services/items/companies_itemsAPI";
import ItemAPI from "@/services/items/itemsAPI";

/**
 * Form elements component
 */
export default {
  page: {
    title: "Pago de Pensión Trabajadores de Alto Riesgo",
    meta: [{ name: "description", content: appConfig.description }],
  },
  components: {
    Layout,
    Style,
    CheckModal,
    PageHeader,
  },
  data() {
    return {
      title: "1.1.5 Pago de Pensión Trabajadores de Alto Riesgo ",
      items: [
        {
          text: "Estándares",
          href: "/",
        },
        {
          text: "Pago de Pensión Trabajadores de Alto Riesgo ",
          active: true,
        },
      ],
      userSelected: null,
      usersList: [],
      lista: [],

      item: null,
      itemStatus: null,

      itemData: null,

      file: null,
      listaII: null,
      ocupationalMedicine: {
        id: null,
        exam_date: null,
        file: null,
        exam_cycles_id: 1,
        employee_id: null,
        archivo: null,
        exam_status: 0,
      },

      pensionTrabajadores: {
        activities: null,
        file: null,
        period: null,
        employee_id: null,
        companies_id: this.$store.getters["company/getCompany"].id || null,
      },

      submitted: false,
      nit: this.$store.getters["company/getCompany"].nit || null,
      companyID: this.$store.getters["company/getCompany"].id || null,
      classificationID: this.$store.getters["company/getCompany"].company_classification_id || null,
      user: this.$store.state.auth || null,

      loading: true,

      list: [
        {
          id: 1,
          name: "Exámenes de ingreso",
        },
        {
          id: 2,
          name: "Exámenes periódicos",
        },
        {
          id: 3,
          name: "examen de retiro",
        },
      ],

      period: [
        {
          id: 1,
          name: "Mes",
        },
        {
          id: 1,
          name: "Año",
        },
      ],

      list: [
        {
          id: 1,
          name: "La Empresa no cuenta con trabajadores con actividades de Alto Riesgo. ",
        },
        {
          id: 2,
          name: "Trabajos en minería que impliquen prestar el servicio en socavones o en subterráneos.  ",
        },
        {
          id: 3,
          name: " Trabajos que impliquen la exposición a altas temperaturas, por encima de los valores límites permisibles, determinados por las normas técnicas de salud de salud ocupacional. ",
        },
        {
          id: 4,
          name: "Trabajos con exposición a radiaciones ionizantes",
        },
        {
          id: 5,
          name: "Trabajos con exposición a sustancias comprobadamente cancerígenas. ",
        },
        {
          id: 6,
          name: "En la Unidad Administrativa Especial de Aeronáutica Civil o la entidad que haga sus veces, la actividad de los técnicos aeronáuticos con funciones de controladores de tránsito aéreo, con licencia expedida o reconocida por la Oficina de Registro de la Unidad Administrativa Especial de Aeronáutica Civil, de conformidad con las normas vigentes. ",
        },
        {
          id: 7,
          name: "En los Cuerpos de Bomberos, la actividad relacionada con la función específica de actuar en operaciones de extinción de incendios.",
        },
        {
          id: 8,
          name: "En el Instituto Nacional Penitenciario y Carcelario, Inpec, la actividad del personal dedicado a la custodia y vigilancia de los internos en los centros de reclusión carcelaria, durante el tiempo en el que ejecuten dicha labor. Así mismo, el personal que labore en las actividades antes señaladas en otros establecimientos carcelarios, con excepción de aquellos administrados por la fuerza pública. ",
        },
      ],
    };
  },
  validations: {
    pensionTrabajadores: {
      activities: {
        required,
      },
      file: {
        required,
      },
      period: {
        required,
      },
      employee_id: {
        required,
      },
    },
  },
  methods: {
    getItemData() {
      ItemAPI.getItems(5)
        .then((response) => {
          this.itemData = response;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    allowAccess() {
      try {
        const item = this.itemData;

        if (item) {
          const classificationID =
            this.$store.getters["company/getCompany"]
              .company_classification_id || null;
          if (classificationID === 1 && item.obligatory_UPA === 1) {
            return true;
          } else if (classificationID === 2 && item.obligatory_groupI === 1) {
            return true;
          } else if (classificationID === 3 && item.obligatory_groupII === 1) {
            return true;
          } else if (classificationID === 4 && item.obligatory_groupIII === 1) {
            return true;
          } else {
            return false;
          }
        } else {
          return false;
        }
      } catch (error) {
        console.log(error);
        return false;
      }
    },

    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(company.id, user ? company.id_diseno_sso : null, messageID, itemID);
    },

    /**
     * This method is used to send notification to SST user and SST company.
     * The sendNotification method import is required.
     * @param {Number} messageID - The message ID that will be associated to notification.
     * @param {Number} itemID - The item ID that will be associated to notification.
     * @param {Boolean} user - The user that will e associated to notification.
     * @return {Boolean} True if the notification is sent, false if not.
     */
    sendNotification(messageID, itemID, user) {
      const company = this.$store.getters["company/getCompany"];
      return sendNotification(
        company.id,
        user ? company.id_diseno_sso : null,
        messageID,
        itemID
      );
    },

    getFile(file) {
      const name = file.split("/");
      return name[name.length - 1];
    },

    /**
     * This method is used to knows if the user has the permission indicated
     * @param {String} name The name of the permission
     * @param {Array} roles the roles that permitted to access the action
     * @returns {Boolean} true if the user has the permission indicated or false if no
     */
    getRole(name, roles) {
      // Get the user role
      let role = this.$store.state.auth.info.role
        ? this.$store.state.auth.info.role
        : null;
      // If the user is logged
      if (role) {
        // If the roles array is not empty
        if (roles) {
          // Know if the role indicated is in the roles array
          role = roles.includes(role) ? true : false;
        } // Close if the roles arrays is not empty
        // If the roles arrays is empty
        else {
          // Know if the user role is in the roles indicated
          role =
            role === 1 || role === 2 || role === 3 || role === 4 || role === 5 || role === 6 || role === 7 || role === 8;
        } // Close if the roles arrays is empty
        // Get the user permissions
        const permissions = this.$store.state.auth.info.permissions;
        // Know if the user has the permission indicated
        const enabled = permissions.find(
          (permission) => permission.name === name
        );
        // If the user has the permission indicated and the user role is in the roles indicated
        return enabled && role ? true : false;
      } // Close if the user is logged
      // If the user is not logged
      else {
        return false;
      } // Close else the user is not logged
    },

    /**
     * This method is used to redirect to the page indicated
     * @param {String} page The page to redirect
     */
    goPage(page) {
      window.location.href = page;
    },

    fetch() {
      this.$refs.paginator.query();
    },

    async uploadFile() {
      this.file = this.$refs.file.files[0];
    },

    async uploadDocument() {
      try {
        let url = "";
        let name = '';

        if (this.file === null) {
          name = this.getFile(this.pensionTrabajadores.file)
        } else {
          name = this.file.name
        }

        if (process.env.VUE_APP_ENV === 'development') {
          url = `sst-dev/${this.nit}/1.1.5/${this.pensionTrabajadores.employee_id}/${name}`;
        } else {
          url = `sst-prod/${this.nit}/1.1.5/${this.pensionTrabajadores.employee_id}/${name}`;
        }

        if (this.file === null) {
          return true;
        } else {
          const result = await uploadDocument(url, this.file);
          if (result) {
            this.pensionTrabajadores.file = `${process.env.VUE_APP_BUCKET}/${url}`;
            return true;
          } else return false;
        }
      } catch (error) {
        console.log(error);
      }
    },

    getData() {
      pensionTrabajadoresAPI
        .getShow(this.$route.params.id)
        .then((response) => {
          this.pensionTrabajadores = {
            activities: response.activities,
            employee_id: response.employee_id,
            file: response.file,
            period: response.period,
            companies_id: response.companies_id,
          };
          this.loading = false;
        })
        .catch((error) => {
          console.log(error);
        });
    },

    async update() {
      this.submitted = true
      this.loading = true
      let response = await this.uploadDocument();
      if (response) {
        pensionTrabajadoresAPI.update(this.$route.params.id, {
          activities: this.pensionTrabajadores.activities,
          file: this.pensionTrabajadores.file,
          period: this.pensionTrabajadores.period,
          employee_id: this.pensionTrabajadores.employee_id,
          companies_id: this.pensionTrabajadores.companies_id,
        })
          .then((response) => {
            const itemChange = {
              companies_id: this.companyID,
              item_id: 5,
              status: 'Pendiente',
            };
            newScoresAPI.calculateScores(itemChange)
              .then((response) => {
                this.loading = false
                setTimeout(() => {
                  Swal.fire({
                    title: "¡Éxito!",
                    text: "¡Informacion actualizada con éxito!",
                    icon: "success",
                    type: "success",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                }, 2000)
                this.$router.go(-1);
              })
              .catch((error) => {
                this.loading1 = false
                setTimeout(() => {
                  Swal.fire({
                    title: "Error",
                    text: "¡No se ha podido actualizar!",
                    icon: "error",
                    type: "error",
                    confirmButtonClass: "btn btn-confirm mt-2",
                  });
                  window.location.reload();
                }, 1000);
                console.log(error);
              })
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.loading = false
        setTimeout(() => {
          Swal.fire({
            title: "Error",
            text: "¡No see ha podido actualizar!",
            icon: "warning",
            type: "error",
            confirmButtonClass: "btn btn-confirm mt-2",
          });
        }, 2000)
      }
    },

    getUsers() {
      CompanyAPI.getCompany(
        this.$store.getters["company/getCompany"].id || null
      )
        .then((response) => {
          EmployeeAPI.getEmployeesOcupationalMedical(response.id).then(
            (res) => {
              this.usersList = res.employee;
            }
          );
        })
        .catch((error) => {
          console.log(error);
        });
    },

    goBack() {
      this.$router.go(-1);
    },

    gotoDigitalOcean(url) {
      window.open(url);
    },

    getItems() {
      CompanyItemsAPI.getStatus(this.companyID, 5)
        .then((response) => {
          this.item = response || null;
          this.itemStatus = response.status ? response.status : null;
        })
        .catch((error) => {
          console.log(error);
        });
    },

  },

  mounted() {
    this.getUsers();
    this.getItems();
    this.getItemData();
    this.getData();
  },
};
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row animated animatedFadeInUp fadeInUp">
      <div class="col-md-12">
        <div class="col-xl-12" v-if="!loading">
          <div class="card">
            <div class="card-body">
              <div class="row">
                <div class="col-md-6 col-sm-12">
                  <CheckModal>
                    <p class="text-justify">
                      Se debe seleccionar las actividades de alto riesgo
                      mencionadas en el Decreto 2090 de 2003, que se realizan en
                      la empresa, en caso de no realizarlas, se seleccionará la
                      opción: La Empresa no cuenta con trabajadores con
                      actividades de Alto Riesgo.
                    </p>
                    <p class="text-justify">
                      Una vez seleccionada la actividad, se debe indicar cuales
                      son los colaboradores que realizan dichas actividades y
                      posteriormente, subir las evidencias del pago de pensiones
                      de cada uno de éstos.
                    </p>
                  </CheckModal>
                </div>
              </div>

              <form class="form-group" @submit.prevent="update">
                <div class="form-row pt-3">
                  <b-form-group id="cycle" label-for="cycle" class="col-md-12 px-2"
                    label="listado de las actividades consideradas como alto riesgo">
                    <table
                      class="pt-2 table border-bottom divide-y divide-gray-200 table-striped rounded style=overflow-y: scroll;">
                      <tbody class="bg-white divide-y divide-gray-200">
                        <tr>
                          <td>
                            <p>{{ pensionTrabajadores.activities }}</p>
                          </td>
                          <td class="text-center align-middle">
                            <input type="checkbox" style="color: #666" disabled checked
                              v-model="pensionTrabajadores.activities" class="mb-2 mr-sm-2 mb-sm-0" label="accidente" />
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </b-form-group>

                  <b-form-group label-for="employee" class="col-md-4 px-2" label="Colaborador">
                    <select :disabled="!getRole('Crear') || !allowAccess()" class="form-control"
                      v-model="pensionTrabajadores.employee_id">
                      <b-form-select-option v-for="item in usersList" :key="item.id" :value="item.id">
                        {{ item.full_name }} - {{ item.position }}
                      </b-form-select-option>
                    </select>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Periodo" label-for="Periodo">
                    <b-form-input :disabled="!allowAccess() || !getRole('Crear')" type="date" id="endDate"
                      v-model="pensionTrabajadores.period">
                    </b-form-input>
                  </b-form-group>

                  <b-form-group class="col-md-4 px-2" label="Subir archivo" label-for="file">
                    <b-form-file :disabled="!getRole('Crear') || !allowAccess()" type="file" id="file" ref="file"
                      name="file" browse-text="Buscar"
                      :placeholder="pensionTrabajadores.file ? getFile(pensionTrabajadores.file) : `Selecciona un archivo...`"
                      drop-placeholder="Suelta acá..."
                      accept=".doc,.pdf, .xlsx, .xls, .docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document"
                      v-model="file" @change="uploadFile" v-on:change="uploadFile">
                    </b-form-file>
                  </b-form-group>
                </div>

                <div class="form-group text-right m-b-0">
                  <button :disabled="submitted" type="submit" class="btn btn-primary">
                    Guardar
                  </button>
                  <button type="button" class="btn btn-secondary mx-1" @click="goBack">
                    Cancelar
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>

        <div v-else class="col-xl-12 text-center">
          <div class="text-center">
            <b-spinner variant="primary" label="Loading..."></b-spinner>
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>